import { ExtendedInfoError } from './ExtendedInfoError';

export class InfrastructureError extends ExtendedInfoError {
    constructor(...args) {
        super(...args);
        this.name = 'InfrastructureError';
    }
}
